const fields = [
  'UE_Kundendaten_Ansprechpartner_Name',
  'UE_Kundendaten_Ansprechpartner_EMail',
  'UE_Kundendaten_Ansprechpartner_Telefon',

  'Avisierung_Kontakt',
  'Avisierung_Email',
  'Avisierung_Telefon',

  'PDB_LIS_Inhaber_abweichend_rechnungsanschrift',
  'PDB_LIS_Inhaber',

  'PDB_LIS_Betreiber_abweichend_connect',
  'PDB_LIS_Betreiber',

  'PDB_Grundstueckseigentuemer_abweichend_LIS',
  'PDB_Grundstueckseigentuemer_Name',
  'PDB_Grundstueckseigentuemer_EMail',
  'PDB_Grundstueckseigentuemer_Telefon',
  'PDB_Grundstueckseigentuemer_Adresse',

  'PDB_Anschlussnutzer_abweichend_LIS',
  'PDB_Anschlussnutzer_Name',
  'PDB_Anschlussnutzer_EMail',
  'PDB_Anschlussnutzer_Telefon',
  'PDB_Anschlussnutzer_Adresse',

  'PDB_Netzbetreiber',
  'PDB_Netzbetreiber_Ansprechperson_Name',
  'PDB_Netzbetreiber_Ansprechperson_Telefon',
  'PDB_Netzbetreiber_Ansprechperson_EMail',
]

const key = 'Projektbeteiligte extern'

export const fieldOrderProjektbeteiligteExtern = { [key]: { fields } }

export const formGroupProjektbeteiligteExtern = {
  key,
  title: key,
  form: key,
}
